export default "/images/9bfc4749169827543383d1951a8047fa.avif";